
<multi-input :inline="true" class="component">
  <column>
    <input
      type="text"
      :value="isSecurityMasked ? maskedValues.masked : maskedValues.unmasked"
      disabled
      v-bind="$attrs"
    >
  </column>
  <suffix v-if="typeof maskedValues.unmasked === 'string'">
    <button class="maskable-field-toggle" @click="isSecurityMasked = !isSecurityMasked">
      <span class="sr-only">Show/hide masked data</span>
      <icon :class="isSecurityMasked ? 'show' : 'hide'"></icon>
    </button>
  </suffix>
</multi-input>
